import {
    NinchatActionType,
    NinchatDeleteIdentityAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const deleteIdentity = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDeleteIdentityAction}`,
    async (arg: NinchatActionParams<NinchatDeleteIdentityAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDeleteIdentityAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
